import { message } from "ant-design-vue"

interface ImageSize {
  width: number;
  height: number;
}

/**
 * 获取图片的原始宽高
 * @param src 图片地址
 */
export const getImageSize = (src: string): Promise<ImageSize> => {
  return new Promise(resolve => {

    const img = document.createElement('img')
    img.src = src
    img.style.opacity = '0'
    document.body.appendChild(img)

    img.onload = () => {
      const imgWidth = img.clientWidth
      const imgHeight = img.clientHeight
    
      img.onload = null
      img.onerror = null

      document.body.removeChild(img)

      resolve({ width: imgWidth, height: imgHeight })
    }

    img.onerror = () => {
      img.onload = null
      img.onerror = null
    }
  })
}

/**
 * 读取图片文件的dataURL
 * @param file 图片文件
 */
export const getImageDataURL = (file: File): Promise<string> => {
  return new Promise(resolve => {
    const reader = new FileReader()
    reader.addEventListener('load', () => {
      resolve(reader.result as string)
    })
    reader.readAsDataURL(file)
  })
}

export const downloadByBlob = (url: string, name: any) => {
  const image = new Image()
  image.setAttribute('crossOrigin', 'anonymous')
  image.src = url
  image.onload = () => {
    const canvas = document.createElement('canvas')
    canvas.width = image.width
    canvas.height = image.height
    const ctx:any = canvas.getContext('2d')
    ctx.drawImage(image, 0, 0, image.width, image.height)
    canvas.toBlob((blob:any) => {
      const url = URL.createObjectURL(blob)
      download(url,name)
      // 用完释放URL对象
      URL.revokeObjectURL(url)
    })
  }
}
const download = (href: string, name: string) => {
  const eleLink = document.createElement('a')
  eleLink.download = name
  eleLink.href = href
  eleLink.click()
  window.URL.revokeObjectURL(eleLink.href)
  eleLink.remove()
}
export const getFileWidthAndHeight = (file: Blob, initwidth: any, initheight: any, hide:any) => {

  return new Promise<void>((resolve, reject) => {
    if (!file) {
      return
    }
    const width = initwidth
    const height = initheight
    const _URL = window.URL || window.webkitURL
    const img = new Image()
    img.src = _URL.createObjectURL(file)
    img.onload = function() {
      const valid = img.width <= width && img.height <= height
      valid ? resolve() : reject()
    }
    img.src = _URL.createObjectURL(file)
  }).then(
    () => {
      return file
    },
    () => {
      message.error("图片像素过大（超出5000px），请压缩后上传！")
      setTimeout(hide, 1)
      return Promise.reject()
    }
  )
}